import React from 'react';
import { ArrowDownward, ArrowUpward, Height } from '@mui/icons-material';
import { CurrentDirection } from './types';

const IconStyles = {
  verticalAlign: 'middle',
};

const CurrentIcon = ({ direction }: { direction: CurrentDirection }) => {
  if (direction === 'ebb') {
    return <ArrowDownward style={IconStyles} />
  }
  if (direction === 'flood') {
    return <ArrowUpward style={IconStyles}/>
  }
  // slack
  return <Height style={IconStyles} />;
};

export default CurrentIcon;